import { useMemo } from "react";

import { InstitutionApprovalRadioGroup } from "./InstitutionApprovalRadioGroup";
import { SimpleApprovalRadioGroup } from "./SimpleApprovalRadioGroup";
import { Institution } from "../../../../models/Institution";
import {
  OutsideEnrollmentAreaStatus,
  EnrollmentDecision,
  Request,
} from "../../../../models/Request";
import {
  isStatusDecisionSuggestedEnrollment,
  isStatusSuggestedEnrollment,
} from "../../../../utils";

interface EnrollmentAreaRadioGroupsProps {
  isEditing: boolean;
  isApproved: boolean;
  onApprovalChange: (isApproved: boolean) => void;
  enrollmentDecision?: EnrollmentDecision;
  primaryInstitution?: Institution;
  secondaryInstitution?: Institution;
  request: Request;
  hasFinalDecision: boolean;
}

export function EnrollmentAreaRadioGroups({
  isEditing,
  isApproved,
  onApprovalChange,
  enrollmentDecision,
  primaryInstitution,
  secondaryInstitution,
  request,
  hasFinalDecision,
}: EnrollmentAreaRadioGroupsProps) {
  const status =
    request.outsideEnrollmentAreaStatus ??
    OutsideEnrollmentAreaStatus.NotProcessed;

  const isStatusSuggestedEnrollmentView = useMemo(() => {
    return isStatusSuggestedEnrollment(status) && !hasFinalDecision;
  }, [status, hasFinalDecision]);

  const showInstitutionApproval =
    isStatusDecisionSuggestedEnrollment(status) && hasFinalDecision;

  return (
    <>
      {isStatusSuggestedEnrollmentView && isEditing && (
        <SimpleApprovalRadioGroup
          isEditing={isEditing}
          isApproved={isApproved}
          onApprovalChange={onApprovalChange}
          status={status}
        />
      )}

      {showInstitutionApproval && (
        <InstitutionApprovalRadioGroup
          isEditing={isEditing}
          isApproved={isApproved}
          onApprovalChange={onApprovalChange}
          primaryInstitution={primaryInstitution}
          secondaryInstitution={secondaryInstitution}
          request={request}
          enrollmentDecision={enrollmentDecision}
        />
      )}
    </>
  );
}
